import { DeheadingValAdditionWorkStatusResponse, GradeToValAdditionResponseModel, InventoryRequest, ValAdditionResponse, ValAdditionResponseModel, ValAdditionSoakingResponseModel, WorkStatusDto } from "@gtpl/shared-models/production-management";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { GradeInventoryRequest } from "./dto/grade-inventory.request";
import { ProductionInventoryData } from "./dto/production-inventory.dto";
import { UnitRequest } from "./dto/unit.id.request";
import { ValAdditionOperationService } from "./val-addition.service";

@ApiTags('val-addition-operation')
@Controller('val-addition-operation')
export class ValAdditionOperationController {
    constructor(
        private valAddOpService: ValAdditionOperationService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      @Post('/AssignValadditionOperation')
     async AssignValadditionOperation(@Body() inputReq: ProductionInventoryData): Promise<ValAdditionResponse>{
         try {
          return await this.valAddOpService.AssignValadditionOperation(inputReq);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(ValAdditionResponse, error);
        }
      }

      @Post('/valAdditionsWipData')
     async valAdditionsWipData(@Body() req:InventoryRequest): Promise<ValAdditionResponseModel>{
         try {
          return await this.valAddOpService.valAdditionsWipData(req);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(ValAdditionResponseModel, error);
        }
      }

      @Post('/valAdditionsReportedData')
      async valAdditionsReportedData(@Body() plantReq:UnitRequest): Promise<ValAdditionSoakingResponseModel>{
          try {
           return await this.valAddOpService.valAdditionsReportedData(plantReq);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(ValAdditionSoakingResponseModel, error);
         }
       }

       
      @Post('/valAdditionWorkStatusInfo')
      async valAdditionWorkStatusInfo(@Body() plantReq:UnitRequest): Promise<DeheadingValAdditionWorkStatusResponse>{
          try {
           return await this.valAddOpService.valAdditionWorkStatusInfo(plantReq);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(DeheadingValAdditionWorkStatusResponse, error);
         }
       }
      @Post('/receiveSubPlantStockInfo')
      async receiveSubPlantStockInfo(@Body() plantReq:UnitRequest): Promise<DeheadingValAdditionWorkStatusResponse>{
          try {
           return await this.valAddOpService.receiveSubPlantStockInfo(plantReq);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(DeheadingValAdditionWorkStatusResponse, error);
         }
       }

       @Post('/jobCompletedStatus')
       async jobCompletedStatus(@Body() workstatusDto:WorkStatusDto): Promise<DeheadingValAdditionWorkStatusResponse>{
           try {
            return await this.valAddOpService.jobCompletedStatus(workstatusDto);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(DeheadingValAdditionWorkStatusResponse, error);
          }
        }
        @Post('/ReportSubPlantOperation')
       async ReportSubPlantOperation(@Body() workstatusDto:WorkStatusDto): Promise<DeheadingValAdditionWorkStatusResponse>{
           try {
            return await this.valAddOpService.ReportSubPlantOperation(workstatusDto);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(DeheadingValAdditionWorkStatusResponse, error);
          }
        }

        

        @Post('/isReceivedStatus')
        async isReceivedStatus(@Body() workstatusDto:WorkStatusDto): Promise<DeheadingValAdditionWorkStatusResponse>{
            try {
             return await this.valAddOpService.isReceivedStatus(workstatusDto);
           } catch (error) {
                return this.applicationExceptionHandler.returnException(DeheadingValAdditionWorkStatusResponse, error);
           }
         }

         @Post('/getGradedInventoryForValAddition')
         async getGradedInventoryForValAddition(@Body() inputReq:GradeInventoryRequest):Promise<GradeToValAdditionResponseModel>{
             try {
              return await this.valAddOpService.getGradedInventoryForValAddition(inputReq);
            } catch (error) {
                 return this.applicationExceptionHandler.returnException(GradeToValAdditionResponseModel, error);
            }
          }

      
}